/* eslint-disable function-paren-newline */
/* eslint-disable prefer-destructuring */
/* eslint-disable max-lines */
/* eslint-disable max-lines-per-function */
/* eslint-disable object-property-newline */
import Button from "@atlaskit/button";
import { ReactElement, useContext, useState } from "react";
import { InsuranceDropDown } from "../../components/InsuranceDropDown/InsuranceDropDown";
import { SelectOpton } from "../../types/SelectedOption";
import Textfield from "@atlaskit/textfield";
import "./GenerateVouchers.scss";
import { Field } from "@atlaskit/form";
import { MessageContext } from "../../contexts/Message/MessageContext";
import { maxVoucherGeneratonAmount } from "../../constants";
import APIService from "../../services/API";
import Papa from "papaparse";
import dayjs from "dayjs";

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface Props {}

export function GenerateVouchers({}: Props): ReactElement {
    const [selectedInsurance, setSelectedInsurance] =
        useState<SelectOpton | null>(null);
    const [voucherNumber, setVoucherNumber] = useState<number>(1);
    const messageContext = useContext(MessageContext);

    const download = (filename: string, text: string) => {
        const element = document.createElement("a");
        element.setAttribute(
            "href",
            `data:text/plain;charset=utf-8,${encodeURIComponent(text)}`
        );
        element.setAttribute("download", filename);

        element.style.display = "none";
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
    };

    const submit = () => {
        if (voucherNumber > maxVoucherGeneratonAmount) {
            return messageContext.actions.showErrorMessage(
                "Es können maximal 1000 Voucher gleichzeitig generiert werden!"
            );
        }
        if (!selectedInsurance) {
            return messageContext.actions.showErrorMessage(
                "Bitte Versicherung auswählen!"
            );
        }
        APIService.handlePostRequest<
            { insuranceId: string; voucherNumber: number },
            string[]
        >(
            {
                insuranceId: selectedInsurance.value,
                voucherNumber,
            },
            "/vouchers/generate"
        )
            .then((res) => {
                const csv = Papa.unparse(
                    res.map((el) => ({
                        Versicherung: selectedInsurance.label,
                        Voucher: el,
                    }))
                );
                download(
                    `${voucherNumber}_Vouchers_${
                        selectedInsurance.label
                    }_${dayjs().format("DD-MM-YYYY_hh:mm")}.csv`,
                    csv
                );
            })
            .catch(() => {
                messageContext.actions.showErrorMessage(
                    "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut!            "
                );
            });
        return 1;
    };

    return (
        <div className="form-wrapper">
            <div className="buttons-cont">
                <div className="voucher-field">
                    <InsuranceDropDown
                        selectedInsurance={selectedInsurance}
                        setSelectedInsurance={setSelectedInsurance}
                    />
                </div>
                <div className="voucher-field">
                    <Field name="numberOfVouchers" label={"Anzahl Voucher"}>
                        {() => (
                            <Textfield
                                label="Anzahl Voucher"
                                type="number"
                                min={1}
                                max={1000}
                                maxLength={4}
                                minLength={1}
                                placeholder=""
                                value={voucherNumber}
                                onChange={(event) => {
                                    /*
                                     * Attlaskit has bad types here
                                     */
                                    // @ts-expect-error - Atlaskit types problem
                                    const value = event.target.value;
                                    setVoucherNumber(value);
                                }}
                            />
                        )}
                    </Field>
                </div>

                <div className="submit">
                    <Button appearance="primary" onClick={() => submit()}>
                        Generieren
                    </Button>
                </div>
            </div>
        </div>
    );
}
